import reactCSS from 'reactcss';
import { headingXs, headingL } from '@ux/type-size';
import cssSides, { Side } from '@team-griffin/css-sides';
import { gu2px } from '@ux/theme-utils';

export default ({
  theme,
  isMinLg,
}) => {
  const {
    spacing,
    typography,
  } = theme;

  return reactCSS({
    default: {
      header: {
        ...cssSides('padding', Side.Y, gu2px(1, spacing)),
      },
      title: {
        ...headingXs(typography),
        marginTop: 0,
        marginBottom: gu2px(1, spacing),
        fontWeight: 'normal',
        display: 'block',
      },
      fqdn: {
        ...headingL(typography),
        marginTop: 0,
        marginBottom: 0,
        fontWeight: 'normal',
        display: 'block',
      },
    },

    isMinLg: {
      header: {
        ...cssSides('padding', Side.X, gu2px(1, spacing)),
        ...cssSides('padding', Side.Y, gu2px(2, spacing)),
      },
    },
  }, [
    { isMinLg },
  ]);
};
